import { AppTableColumn } from '../../_models/models';

export type SortDirectionType = 'ASC' | 'DESC';

export function getSmartSortDirection(column: AppTableColumn): SortDirectionType {
  if (column.initialSortDirection) {
    return column.initialSortDirection;
  }

  const prop = column.prop?.toLowerCase() || '';
  const type = column.type?.toLowerCase() || '';

  if (prop.includes('id') || prop.includes('external')) {
    return 'DESC';
  }

  if (type === 'date' || type === 'date-and-time' ||
      prop.includes('date') || prop.includes('time') ||
      prop.includes('created') || prop.includes('updated')) {
    return 'DESC';
  }

  if (type === 'number' || type === 'number-with-commas') {
    return 'DESC';
  }

  if (prop.includes('count') || prop.includes('total') ||
      prop.includes('amount') || prop.includes('revenue') ||
      prop.includes('price') || prop.includes('cost')) {
    return 'DESC';
  }

  return 'ASC';
}
